import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const className = 'Utils';

@Injectable({providedIn: 'root'})
export class Utils {
  makeImageURL(imagePath: string) {
    return `${environment.imageUrl}${imagePath}`;
  }

  roundToPlaces = (num: number, places = 2) => {
    let rounded = Math.round(num * Math.pow(10, places)) / Math.pow(10, places);
    return parseFloat(rounded.toFixed(places));
  };

  twoDecimalPlacesString = (num: number) => {
    if (!num) {
      return '0.00';
    }

    let val = this.roundToPlaces(num, 2).toString();
    let decimalMatches = val.match(/\.[0-9]+$/);
    if (decimalMatches && decimalMatches.length > 0) {
      let decimal = decimalMatches[0];
      if (decimal.length < 3) {
        decimal += '0';
      }
      val = val.replace(/\.[0-9]+$/, decimal);
    } else {
      val += '.00';
    }

    return val;
  };
}
